/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Level7_Interactive_RoleInputs */

const en_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Engineer`)
};

const ar_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهندس برمجيات`)
};

const bn_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ইঞ্জিনিয়ার`)
};

const de_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler`)
};

const es_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeniero de software`)
};

const fr_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur logiciel`)
};

const pt_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engenheiro de software`)
};

const zh_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件工程师`)
};

const tr_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Mühendisi`)
};

const ru_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инженер-программист`)
};

const pl_experience_level7_interactive_role = /** @type {(inputs: Experience_Level7_Interactive_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inżynier oprogramowania`)
};

/**
* | output |
* | --- |
* | "Software Engineer" |
*
* @param {Experience_Level7_Interactive_RoleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_level7_interactive_role = /** @type {((inputs?: Experience_Level7_Interactive_RoleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Level7_Interactive_RoleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_level7_interactive_role(inputs)
	if (locale === "bn") return bn_experience_level7_interactive_role(inputs)
	if (locale === "de") return de_experience_level7_interactive_role(inputs)
	if (locale === "es") return es_experience_level7_interactive_role(inputs)
	if (locale === "fr") return fr_experience_level7_interactive_role(inputs)
	if (locale === "pt") return pt_experience_level7_interactive_role(inputs)
	if (locale === "zh") return zh_experience_level7_interactive_role(inputs)
	if (locale === "tr") return tr_experience_level7_interactive_role(inputs)
	if (locale === "ru") return ru_experience_level7_interactive_role(inputs)
	if (locale === "pl") return pl_experience_level7_interactive_role(inputs)
	return en_experience_level7_interactive_role(inputs)
});